<app-header></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="isFooterVisible()"></app-footer>
